import { DataProvider, useSetFlowToBasedOnData } from 'Simple/Data'
import useFetch from 'Data/useFetch'
import useDataConfiguration from './useDataConfiguration.js'
import React from 'react'
import View from './view.js'

/** @type {import('Simple/types.js').Data} */
export default function NoteData(props) {
  let configuration = useDataConfiguration(props)
  let [{ data, error }] = useFetch(configuration.variables.url, {
    cache: 'reload',
  })

  useSetFlowToBasedOnData({
    data,
    fetching: !data,
    error,
    pause: configuration.pause,
    viewPath: props.viewPath,
  })

  return (
    <DataProvider context="content" value={data} viewPath={props.viewPath}>
      <View {...props} />
    </DataProvider>
  )
}
